import { useContext, useMemo } from 'react';
import VodapayContext from 'contexts/vodapay';
import { useQuery } from '@apollo/client';
import {
  ConfigurableMessageSection,
  QueryConfigMessagesOutput,
} from 'types/types';
import configMessagesQuery from 'queries/configMessages.graphql';
import { getConfigurableMessage } from '../util/configurable-messages';
import GlobalStatusesContext from 'contexts/global-statuses';

export const useVodapay = () => {
  const { vodapay } = useContext(VodapayContext);
  return vodapay;
};

export const useVodapayActive = () => {
  const {
    vodapay: { isActive },
  } = useContext(VodapayContext);
  return isActive;
};

export const useSetVodapayEventListeners = () => {
  const { setVodapayEventListeners } = useContext(VodapayContext);
  return setVodapayEventListeners;
};

/**
 * NOTE: this was originally implemented to be separate from VP.
 * But it's been a few years now and is still only used there.
 * I don't actually like the nav bar anyway, so logic has been changed to tie directly to VP.
 */
export const useNavigationBarActive = () => {
  const { vodapay } = useContext(VodapayContext);
  return vodapay.isActive;
};

export const useHasGlobalStatus = (status: string) => {
  const { globalStatuses } = useContext(GlobalStatusesContext);
  return useMemo(() => globalStatuses.includes(status), [
    globalStatuses,
    status,
  ]);
};

export const useAddGlobalStatus = () => {
  const { addGlobalStatus } = useContext(GlobalStatusesContext);
  return addGlobalStatus;
};

export const useRemoveGlobalStatus = () => {
  const { removeGlobalStatus } = useContext(GlobalStatusesContext);
  return removeGlobalStatus;
};

const useConfigMessagesQuery = () => {
  const { data } = useQuery<QueryConfigMessagesOutput>(configMessagesQuery);
  return data;
};

export const useGlobalConfigMessage = (
  section?: ConfigurableMessageSection
) => {
  const isVodapayActive = useVodapayActive();
  const data = useConfigMessagesQuery();

  return getConfigurableMessage(
    isVodapayActive,
    data?.configs.messages,
    section
  );
};
